import styled from "styled-components";

// https://css-tricks.com/NetMag/FluidWidthVideo/Article-FluidWidthVideo.php
const YoutubeVideoIFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const YoutubeVideoContainer = styled.div`
  position: relative;
  /* 100 is for 1:1 ratio (DEFAULT),  56.25% for 16:9 */
  padding-bottom: ${(props) => props.ratioPercent || 100}%;
  padding-top: 25px;
  height: 0;
`;

export { YoutubeVideoIFrame, YoutubeVideoContainer };
